import { ThisWeek } from '../components/ThisWeek.tsx';

/** The app's default route (T-075) — see `ThisWeek`'s own comment for what
 * it renders. The squad desk itself moved to `/squad`; see `squadRoute.tsx`. */
export function ThisWeekRoute() {
  return <ThisWeek />;
}
